enum SalesPriceTypeCodeEnum {
	regularSalesUnitPrice = 'RegularSalesUnitPrice',
	familySalesUnitPrice = 'IKEAFamilySalesUnitPrice'
}

export default SalesPriceTypeCodeEnum;
